var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hasHeader),expression:"!$route.meta.hasHeader"}]}),_c('div',{staticClass:"max-w-2xl mx-auto"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }